import { render } from "./AddTaxAddressModal.vue?vue&type=template&id=183270d8&scoped=true"
import script from "./AddTaxAddressModal.vue?vue&type=script&lang=js"
export * from "./AddTaxAddressModal.vue?vue&type=script&lang=js"

import "./AddTaxAddressModal.vue?vue&type=style&index=0&id=183270d8&lang=scss&scoped=true"

import exportComponent from "D:\\a\\_work\\1\\s\\vue-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183270d8"]])

export default __exports__